import { styled } from 'linaria/react';
import { FONTS } from 'styles/constants';

export const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
`;

export const TimeSince = styled.div`
  color: currentColor;
  opacity: 0.7;
  font-size: 12px;
  font-family: ${FONTS.secondary};
  line-height: 1;
  margin-right: 4px;
`;

export const IconButtonWrapper = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    display: block;
  }
`;

export const IconLink = styled.a`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    display: block;
  }
`;
